import React, { useContext } from "react";
import { PhotoManagerContext } from "../index";
const warningIcon = require("../../styles/images/warning.svg");
import { Album } from "../types";

type SubscriptionCtaType = {
  source: "breadcrumb" | "photogrid";
  setShowSubscriptionPopup: React.Dispatch<
    React.SetStateAction<boolean>
  > | null;
  selectedEventId: number;
  selectedAlbum: Album | null;
};

const SubscriptionCta = ({
  source,
  setShowSubscriptionPopup,
  selectedEventId,
  selectedAlbum
}: SubscriptionCtaType) => {
  const context = useContext(PhotoManagerContext);
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowSubscriptionPopup?.(true);
  };
  const SubscriptionCtaWrapper = React.memo(({ label }: { label: string }) => {
    return (
      <button className="geo-btn geo-btn--secondary-link" onClick={handleClick}>
        {label}
      </button>
    );
  });
  const PhotogridSubscriptionCta = () => {
    if (
      selectedAlbum?.hasFreeSharingSubscription &&
      selectedAlbum?.canManageFreeSharingSubscription
    ) {
      return <SubscriptionCtaWrapper label="Reactivate Subscription" />;
    }

    if (
      !selectedAlbum?.hasFreeSharingSubscription &&
      selectedAlbum?.canCreateFreeSharingSubscription
    ) {
      return <SubscriptionCtaWrapper label="Subscribe Now" />;
    }

    return (
      <div className="upload-cta-info">
        <span className="secondary-text">
          Please contact the event organizer.
        </span>
      </div>
    );
  };

  const tooltipContent = () => {
    if (
      selectedAlbum?.hasFreeSharingSubscription &&
      selectedAlbum?.canManageFreeSharingSubscription
    ) {
      return "Your subscription has been cancelled. To continue uploading photos, please reactivate your plan.";
    }

    if (
      !selectedAlbum?.hasFreeSharingSubscription &&
      selectedAlbum?.canCreateFreeSharingSubscription
    ) {
      return "In order to upload photos to free events, you need to subscribe.";
    }

    return "Please contact the event organizer.";
  };
  const BreadCrumbSubscriptionCta = () => {
    return (
      <button
        id={`subscribe-icon-${selectedEventId}`}
        className="geo-btn geo-btn--small geo-btn--secondary geo-btn--caps ws-upld-btn upld-waning-btn"
        onClick={handleClick}
        data-toggle="tooltip"
        data-placement="bottom"
        onMouseEnter={() =>
          context?.showActionTooltip(
            selectedEventId,
            tooltipContent(),
            "subscribe"
          )
        }
      >
        <img src={warningIcon} alt="warning" />
        Upload Photos
      </button>
    );
  };

  if (source == "photogrid") {
    return <PhotogridSubscriptionCta />;
  }
  return <BreadCrumbSubscriptionCta />;
};
export default SubscriptionCta;
